module.exports = __webpack_public_path__ + "static/consistent-1471124eb44ec3a4de02295a496601a3.png";